<template>
    <div class='more'>
        <div v-if="sure" class="fl1 loads">
            <div class="xql">
                <van-loading size="26px" color="#fff" type="spinner" vertical>加载中...</van-loading>
            </div>
        </div>
        <div style="display: flex;margin-bottom: .8rem;">
            <van-cell title="选择日期" :value="date" @click="show = true" />
            <van-calendar v-model="show" :show-confirm="false" :min-date="minDate" :max-date="maxDate" type="range"
                @confirm="onConfirm" :allow-same-day="true" />
        </div>
        <div class="gain_mx_con">
            <div style="margin: .8rem 0;">{{ this.data.day }}</div>
            <div class="gain_mx_box">
                <div>分账订单：{{ this.data.order_num }}笔</div>
                <div class="w45">分账金额：<span style="color: #67c23a;">{{ this.data.amount }}元</span></div>
            </div>
        </div>
        <van-list :finished="finished" finished-text="没有数据了" v-model="loading" @load="onLoad" offset="120"
            :immediate-check='nos' v-if="list.length != 0">
            <div class="gain_mx_con" v-for="(v, k) in list" :key="k">
                <div style="margin: .8rem 0;">{{ v.day }}</div>
                <div class="gain_mx_box">
                    <div>分账订单：{{ v.order_num }}笔</div>
                    <div class="w45">分账金额：<span style="color: #67c23a;">{{ v.amount }}元</span></div>
                </div>
                <div class="fl1 payment-info" v-if="v.settle_state != ''">
                    <div>汇付结算：{{ v.settle_amt }}元 </div>
                    <img src="../../assets/qwu.png" v-if="v.settle_state == 'S'">
                    <img src="../../assets/cw.png" v-if="v.settle_state == 'F'">
                    <img src="../../assets/jz.png" class="rotate" v-if="v.settle_state == 'P'">
                </div>
                <div class="gain_mx_box" v-if="v.settle_state == 'F'">失败原因：{{ v.settle_msg }}</div>
            </div>
        </van-list>
        <img src="../../assets/ww.png" style="width: 100%;" v-else>
        <scrollTop v-if="list.length != 0"></scrollTop>
    </div>
</template>

<script>
import { getDataList, getDataT } from "../../api/index"
import scrollTop from "@/components/scroll.vue"
export default {
    components: { scrollTop },
    data() {
        return {
            loading: false,
            nos: false,
            data: {},
            date: '',
            date1: '',
            date2: '',
            sure: true,
            finished: false,
            refreshing: false,
            endDate: '',
            list: [],
            show: false,
            minDate: this.$store.state.mindate,
            maxDate: new Date(),
        };
    },
    methods: {
        async get() {
            this.sure = true;
            getDataList({
                member_id: localStorage.getItem("MemberId"),
                mch_id: localStorage.getItem("MchId"),
                vender_id: localStorage.getItem("VenderId"),
                nextdate: this.endDate,
                startdate: this.date1,
                enddate: this.date2
            }).then((data) => {
                if (data.code == 1) {
                    const { list, nextdate } = data.data;
                    const newList = Object.entries(list).map(([date, details]) => ({
                        date,
                        ...details
                    })).sort((a, b) => new Date(b.date) - new Date(a.date));
                    this.endDate = nextdate;
                    this.list = [...this.list, ...newList];
                    this.loading = false;
                    if ((this.date1 > this.endDate) && newList.length == 0) {
                        this.finished = true;
                    }
                }
                this.sure = false;
            })
        },
        onLoad() { this.get() },
        formatDate(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        },
        onConfirm(date) {
            const [start, end] = date;
            this.show = false;
            this.date1 = this.formatDate(start);
            this.date2 = this.formatDate(end);
            this.date = `${this.formatDate(start)} / ${this.formatDate(end)}`;
            this.endDate = '';
            this.list = [];
            this.finished = false;
            this.getD();
            this.get();
        },
        async getD() {
            const { data } = await getDataT({
                member_id: localStorage.getItem("MemberId"),
                mch_id: localStorage.getItem("MchId"),
                vender_id: localStorage.getItem("VenderId"),
                startdate: this.date1,
                enddate: this.date2,
            });
            this.data = data;
        },
    },
    mounted() {
        this.date1 = this.formatDate(new Date(new Date() - 30 * 24 * 60 * 60 * 1000));
        this.date2 = this.formatDate(new Date());
        this.endDate = this.date2;
        this.date = `${this.date1} / ${this.date2}`;
        this.getD();
        this.get();
    }
}
</script>
<style lang='less'>
.more {
    padding: 1rem;

    .van-cell {
        padding: 10px 30px 10px 16px;
    }

    .gain_mx_con {
        padding: .6rem 1.6rem .6rem;
        background-color: #fff;
        border-radius: .6rem;
        margin: 0 0 .8rem;

        .gain_mx_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 1rem 0;
            font-size: 1.5rem;
        }

        .w45 {
            width: 45%;
        }
    }

    .payment-info {
        margin: .8rem 0;
        display: flex;
        align-items: center;
    }

    .van-calendar__day--middle {
        color: #1260FC;
    }

    .van-cell__title {
        color: #1260FC !important;
    }

    .van-calendar__day--end,
    .van-calendar__day--multiple-middle,
    .van-calendar__day--multiple-selected,
    .van-calendar__day--start,
    .van-calendar__day--start-end {
        background-color: #1260FC;
        border-radius: .6rem;
    }

    .van-cell__title {
        -webkit-box-flex: 0.8;
        -webkit-flex: 0.8;
        flex: 0.8;
    }

    .van-cell {
        border-radius: 1rem;
    }

    .van-cell__value {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        white-space: nowrap;
    }

    .payment-info img {
        width: 1.6rem;
        margin-left: .3rem;
    }

    @keyframes rotateAnimation {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }

    .rotate {
        animation: rotateAnimation 3s linear infinite;
    }
}
</style>